import { useEffect } from "react";
import { useToast } from "@hiya/ui";
import { listReportsPublished, markTabViewed } from "../../../api/orders";
import { useKitList } from "../../../hooks/useKitList";
import { useNotes } from "../../../hooks/useNotes";
import { KitListLayout } from "../../../components/orders/KitListLayout";
import { NotePopover } from "../../../components/orders/NotePopover";
import { formatDate } from "../../../utils/formatDate";

const COLUMNS = ["User Name", "Day of Cycle", "Order ID", "Kit ID", "Publish Date", "Assigned Doctor", "Notes"] as const;

export function ReportsPublishedPage() {
  const { toast, showToast } = useToast();
  const kit = useKitList(listReportsPublished);
  const notes = useNotes({ updateItem: kit.updateItem, showToast });

  useEffect(() => {
    markTabViewed("reports_published").catch(() => showToast("Something went wrong. Please refresh the page.", "warning"));
  }, [showToast]);

  return (
    <KitListLayout
      kit={kit}
      toast={toast}
      columns={COLUMNS}
      renderRow={(item) => (
        <>
          <td className="px-4 py-3 text-sm text-text-primary">{item.user_name || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.cycle_dayphase || "-"}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.order_id}</td>
          <td className="px-4 py-3 text-sm text-text-primary">{item.kit_code}</td>
          <td className="px-4 py-3 text-sm text-text-primary" title={item.updated_at ? new Date(item.updated_at).toISOString() : ""}>
            {formatDate(item.updated_at)}
          </td>
          <td className="px-4 py-3">
            <div className="flex flex-col items-center gap-0.5">
              <span className="text-sm text-text-primary">{item.assigned_doctor_name || "-"}</span>
              {item.assigned_doctor_email && (
                <span className="text-xs text-text-tertiary">{item.assigned_doctor_email}</span>
              )}
            </div>
          </td>
          <td className="px-4 py-3">
            <NotePopover
              note={item.note}
              onSave={(text) => notes.handleSaveNote(item.record_id, text, !!item.note)}
              onDelete={() => notes.handleDeleteNote(item.record_id)}
            />
          </td>
        </>
      )}
    />
  );
}
